import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Filters } from "./styles";
import { Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import { useAuth } from "../../../../../contexts/authContext";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import { get_agents_panel_page } from "../../../../../api/endpoints/agents";

// Bit flags iguales a AgentCapabilities en API
// 001
const CAP_SELLER = 1;
// 010
const CAP_ASSISTANT = 2;
// 100
const CAP_MULTI_CLIENT = 4;

const getAgentCapabilities = (agent) => {
	let caps = 0;

	if (agent.isSeller) caps |= CAP_SELLER;
	if (agent.isAssistant) caps |= CAP_ASSISTANT;
	if (agent.isMultiClient) caps |= CAP_MULTI_CLIENT;

	return caps;
};

const getAgentTypeLabel = (agent) => {
	const caps = getAgentCapabilities(agent);

	switch (caps) {
		case 0:
			return "Agente por defecto";

		case CAP_SELLER: // Seller
			return "Vendedor laboratorio";

		case CAP_ASSISTANT: // Assistant
			return "Asistente";

		case CAP_MULTI_CLIENT: // MultiClient
			return "Agente multicliente";

		case CAP_SELLER | CAP_ASSISTANT: // Seller + Assistant
			return "Vendedor + Asistente";

		case CAP_SELLER | CAP_MULTI_CLIENT: // Seller + MultiClient
			// En backend: MultiClientSellerAgentToolStrategy
			return "Vendedor multicliente";

		case CAP_ASSISTANT | CAP_MULTI_CLIENT: // Assistant + MultiClient
			return "Asistente multicliente";

		case CAP_SELLER | CAP_ASSISTANT | CAP_MULTI_CLIENT:
			return "Vendedor + Asistente multicliente";

		default:
			return "Tipo desconocido";
	}
};

export default function AgentPanelList() {
	const navigate = useNavigate();
	const { userdata } = useAuth();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "name",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/agentPanel/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{record.client.name}
					</Typo>
				</Link>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Tipo</div>,
			dataIndex: "agentType",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/agentPanel/${record.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{getAgentTypeLabel(record)}
					</Typo>
				</Link>
			),
		},
	];

	const fetch_data_agent_clients = async (page, search) => {
		const res = await get_agents_panel_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_agent_clients(1, "");
	}, [state]);

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de Agentes
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters>
					<Space size="large">
						{userdata.isOneMarket && (
							<DropShadow type="drop">
								<SignInTemplate.AntdButton
									type="primary"
									bg="Primary"
									color="White"
									icon={<PlusOutlined />}
									onClick={() =>
										navigate("/admin/agentPanel/create?uri=" + uri)
									}
									style={{ width: "200px", fontWeight: "400" }}
								>
									Crear Agente
								</SignInTemplate.AntdButton>
							</DropShadow>
						)}
					</Space>
				</Filters>
				<DataTable
					data={data}
					fetch={fetch_data_agent_clients}
					columns={columns}
				/>
			</Main.Body>
		</Main>
	);
}
